export const fetchContentUrl = (appConfig, contentUrl) => {
    const {enableHybrid, alias} = appConfig
    if (!enableHybrid && !alias && !alias?.hostname) return contentUrl

    const url = new URL(contentUrl)
    url.hostname = alias?.hostname
    return url.toString()
}
